import { createSvgComponent } from "../../icon/createSvgComponent";
import Camera from "@core/__generated__/icon/figma/camera.svg";
export default createSvgComponent(Camera);